/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ plan: NonNullable<unknown> }} Plan_Gate_Requires_PlanInputs */



/**
* | output |
* | --- |
* | "This feature requires the {plan} plan or higher." |
*
* @param {Plan_Gate_Requires_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_gate_requires_plan = /** @type {((inputs: Plan_Gate_Requires_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Gate_Requires_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Funktion erfordert den ${i?.plan}-Plan oder höher.`)
	return /** @type {LocalizedString} */ (`This feature requires the ${i?.plan} plan or higher.`)
});